import { EStatusHistory } from "../interfaces/IQuery";
import { IColor } from "./selectColors";

interface IStatusHistory {
  title: string;
  color: IColor;
}

export function colorStatusHistory(status: EStatusHistory): IStatusHistory {
  const statusMap = {
    [EStatusHistory.Error]: {
      color: IColor.red,
      title: "global.status_history.error",
    },
    [EStatusHistory.CancelledByUser]: {
      color: IColor.red,
      title: "global.status_history.cancelled",
    },
    [EStatusHistory.CancelledByAnalyst]: {
      color: IColor.red,
      title: "global.status_history.cancelled",
    },
    [EStatusHistory.Accepted]: {
      color: IColor.green,
      title: "global.status_history.accepted",
    },
    [EStatusHistory.Executed]: {
      color: IColor.green,
      title: "global.status_history.accepted",
    },
    [EStatusHistory.Scheduled]: {
      color: IColor.yellow,
      title: "global.status_history.scheduled",
    },
    [EStatusHistory.Info]: {
      color: IColor.orange,
      title: "global.status_history.info",
    },
    [EStatusHistory.InProcessing]: {
      color: IColor.orange,
      title: "global.status_history.in_processing",
    },
  };

  const selected = statusMap[status] || {
    title: "global.status_history.unknown",
    color: IColor.red,
  };

  return {
    title: selected.title,
    color: selected.color,
  };
}
